var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatalogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_487_1010)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 18C25.5523 18 26 18.4477 26 19V20H30V19C30 18.4477 30.4477 18 31 18C31.5523 18 32 18.4477 32 19V20H33C34.6569 20 36 21.3431 36 23V35C36 36.6569 34.6569 38 33 38H23C21.3431 38 20 36.6569 20 35V23C20 21.3431 21.3431 20 23 20H24V19C24 18.4477 24.4477 18 25 18ZM30 22V23C30 23.5523 30.4477 24 31 24C31.5523 24 32 23.5523 32 23V22H33C33.5523 22 34 22.4477 34 23V35C34 35.5523 33.5523 36 33 36H23C22.4477 36 22 35.5523 22 35V23C22 22.4477 22.4477 22 23 22H24V23C24 23.5523 24.4477 24 25 24C25.5523 24 26 23.5523 26 23V22H30ZM24 27C24 26.4477 24.4477 26 25 26H31C31.5523 26 32 26.4477 32 27C32 27.5523 31.5523 28 31 28H25C24.4477 28 24 27.5523 24 27ZM25 30C24.4477 30 24 30.4477 24 31C24 31.5523 24.4477 32 25 32H28C28.5523 32 29 31.5523 29 31C29 30.4477 28.5523 30 28 30H25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_487_1010",
    x1: 0,
    y1: 28,
    x2: 56,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF914C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogo);
export default __webpack_public_path__ + "static/media/catalogo.602d07c3e496f50712bc8fd0a0dfd211.svg";
export { ForwardRef as ReactComponent };